export default "/assets/2749908e1220853a.svg"